import type { PaginationData } from 'models';
import { useInfiniteQuery } from 'query';
import { getTodos } from '../../services';
import { type Todo, createTodo } from '../../types';
import { getTodosInfiniteQueryKey } from './keys';

export type TodosQueryParams = {
  date?: string;
  featured: boolean;
  pageSize: number;
};

export const useTodosQuery = ({ date, featured, pageSize }: TodosQueryParams) =>
  useInfiniteQuery<PaginationData<Todo>, string | undefined>({
    gcTime: 0,
    async queryFn({ pageParam: cursor }) {
      const { data: todos } = await getTodos({ config: { params: { cursor, date, featured, limit: pageSize } } });

      return {
        data: todos.data.map((todoDataObject) => createTodo(todoDataObject)),
        total: todos.total,
      };
    },
    initialPageParam: undefined,
    getNextPageParam: (lastPage) => (lastPage.data.length === pageSize ? lastPage.data.at(-1)?.id : undefined),
    queryKey: getTodosInfiniteQueryKey({ filter: { date, featured, pageSize } }),
    refetchInterval: 5 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
  });
